import React, { ReactElement } from 'react';
import { Box, SxProps, useTheme } from '@mui/material';
import AppCustomIcon from '../icon/AppIcon';
type AppFormatBooleanProps = {
	value: boolean;
	textIfNull?: string | ReactElement;
	textIfTrue?: string | ReactElement;
	textIfFalse?: string | ReactElement;
	sx?: SxProps;
	colorSuccess?: string;
	colorError?: string;
	hideIcon?: boolean;
};
const AppFormatBoolean = (props: AppFormatBooleanProps) => {
	const { value, textIfNull, textIfTrue, textIfFalse, sx, colorSuccess, colorError, hideIcon } = props;
	const theme = useTheme();
	return (
		<Box component="span" sx={sx ?? null}>
			{value === true ? (
				<>
					{!hideIcon ? <AppCustomIcon tag="save" style={{ color: theme.palette.success.main }} /> : <></>}
					<Box component="span" style={{ color: colorSuccess ?? theme.palette.success.main }}>
						{textIfTrue ? textIfTrue : ''}
					</Box>
				</>
			) : value === false ? (
				<>
					{!hideIcon ? (
						<AppCustomIcon tag="user_protect" style={{ color: theme.palette.success.main }} />
					) : (
						<></>
					)}
					<Box component="span" style={{ color: colorError ?? theme.palette.error.main }}>
						{textIfFalse ? textIfFalse : ''}
					</Box>
				</>
			) : (
				textIfNull ?? <>{!hideIcon ? <></> : <></>}</>
			)}
		</Box>
	);
};

export default AppFormatBoolean;
